/*
 * Self-contained enquiry modal controller.
 *
 * Loaded as a CLASSIC, deferred script (not an ES module) and uses only vanilla
 * JS, so it works independently of the large `custom.js` module — which is an
 * ES module that imports from a CDN + the theme bundle and does not reliably
 * bind its delegated handlers on the minified live storefront. This keeps the
 * "Send Enquiry" button working regardless of that module's state.
 *
 * Responsibilities: open/close the modal, refresh the auto-filled product and
 * variant fields on open, prime the country field, and trigger the lazy
 * Turnstile load. Submission itself belongs to assets/native-form.js.
 */
(function () {
  "use strict";

  function modal() {
    return document.querySelector(".inquiry-model");
  }
  function openModal() {
    var m = modal();
    if (m) m.classList.add("model-open");
    // Turnstile is only fetched once someone actually opens the form.
    if (window.BajaTurnstile) window.BajaTurnstile.load();
  }
  function closeModal() {
    var m = modal();
    if (m) m.classList.remove("model-open");
  }
  function setText(id, value) {
    var el = document.getElementById(id);
    if (el && value) el.textContent = value;
  }
  function setVal(id, value) {
    var el = document.getElementById(id);
    if (el && value) el.value = value;
  }

  // Refresh the display block + hidden fields from the currently selected
  // variant. Liquid already renders sensible server-side defaults; this refines
  // them when the variant was changed client-side (no reload).
  function refreshFields() {
    setVal("enquiry-f-url", window.location.href);

    var titleEl = document.querySelector("h1.hdt-product__title");
    var name = titleEl ? titleEl.textContent.trim() : "";
    if (name) {
      setText("enquiry-product-name", name);
      setVal("enquiry-f-product", name);
      setVal("enquiry-f-subject", "Wheel Enquiry: " + name);
    }

    var sv =
      window.selectedVariant ||
      (window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.selectedVariant);
    if (sv && sv.options && sv.options.length) {
      var size = sv.options[0] || "";
      var color = sv.options[1] || "";
      if (size) {
        setText("enquiry-size-result", size);
        setVal("enquiry-f-size", size);
      }
      if (color) {
        setText("enquiry-color-result", color);
        setVal("enquiry-f-color", color);
      }
    }

    var img = document.querySelector(
      ".hdt-product__media-item.is-selected.is-in-view .hdt-product__media img"
    );
    var imgEl = document.getElementById("enquiry-product-image");
    if (img && imgEl && img.getAttribute("src")) {
      imgEl.setAttribute("src", img.getAttribute("src"));
    }
  }

  // Best-effort country/IP into the optional hidden Country field.
  function fillCountry() {
    var el = document.getElementById("enquiry-f-country");
    if (!el) return;
    fetch("https://ipapi.co/json/")
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        el.value =
          (d.country_name || "Unknown Country") + ", IP: " + (d.ip || "Unknown IP");
      })
      .catch(function () {
        el.value = "Unknown, IP: Unknown";
      });
  }

  // Delegated click handling (works even though the button/modal render inside a
  // section that the theme may re-render).
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(".inquiry-open")) {
      e.preventDefault();
      openModal();
      refreshFields();
      return;
    }
    if (
      t.closest(".inquiry-model .close-btn-model") ||
      t.closest(".inquiry-model .bg-overlay-modal")
    ) {
      closeModal();
    }
  });

  // Submit is deliberately NOT handled here. assets/native-form.js owns it for
  // every .native-form__form: honeypot, loading state, AJAX post to the Worker,
  // error messages and the Turnstile reset. Two submit handlers on one form is
  // how you end up unable to tell which one swallowed the event.

  // The form now posts by fetch, so there is no reload to recover from — the
  // success block renders in place. Only the country lookup needs priming.
  function init() {
    fillCountry();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
